import { z } from 'zod';
import { BankAccountPayload, BaseBankAccountPayloadSchema } from './bank-account.payload.entity';

export const CnapsBankAccountPayloadSchema = BaseBankAccountPayloadSchema.merge(
    z.object({
        accountNumber: z.string(),
        routingNumber: z.string(),
    }),
);

export class CnapsBankAccountPayload extends BankAccountPayload {
    accountNumber: string;
    routingNumber: string;
}
